import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, MagnifyingGlassIcon, FileTextIcon } from '@radix-ui/react-icons';
import InvoiceCard from '../components/Documents/InvoiceCard';
import { formatDate } from '../utils/dateUtils';

// Mock invoice data based on the provided schema
const mockInvoices = [
  {
    id: "1",
    invoice_number: "97511742",
    vat_number: "",
    invoice_credit_note: "Invoice",
    date: "04-07-2016",
    description_particulars: "Video game consoles and bundles including Nintendo Wii, Sony PlayStation 5, Microsoft Xbox One S, and related accessories.",
    supplier_name: "Decker PLC",
    net: 4314.93,
    vat_percentage: 10,
    vat_amount: 431.49,
    gross: 4746.42,
    cis: 0,
    from_address: "PSC 4781, Box 6245\nAPO AE 78725\nTax Id: 957-87-4031\nIBAN: GB49WFLF18981790361495",
    to_address: "42517 Laurie Passage Suite 826\nNorth Charleshaven, NC 09365\nTax Id: 993-86-3706",
    payment_details: "",
    items: [
      {
        name: "Nintendo Wii New Super Mario Bros Console System Bundle Gamecube Compatible",
        price: 89.99
      },
      {
        name: "Sony PlayStation 5 Console - White - Disc Version - CONFIRMED PRE ORDER PS5",
        price: 499.99
      },
      {
        name: "Microsoft XBOX One S 1TB Console - White",
        price: 945
      },
      {
        name: "Nintendo Wii Teal Blue Limited Edition Console with Mario Kart - MINT TESTED",
        price: 229.98
      },
      {
        name: "Sony PlayStation 5 Console - PS5- PRESALE: Disc Version Pre Order Confirmed",
        price: 2549.97
      }
    ],
    bank_account_details: "IBAN: GB49WFLF18981790361495",
    pdf_url: "https://xelp-flowise.s3.amazonaws.com/KnowledgeBase/2a29dbb8-3847-4133-a14e-e13f55652554/2a29dbb8-3847-4133-a14e-e13f55652554_VISIONXELP_scanner@baileygroup.co.uk_20250625_161931.pdf"
  },
  {
    id: "2",
    invoice_number: "85632147",
    vat_number: "GB123456789",
    invoice_credit_note: "Invoice",
    date: "12-08-2016",
    description_particulars: "Office supplies including paper, pens, notebooks, and printer ink cartridges.",
    supplier_name: "Office Solutions Ltd",
    net: 1250.00,
    vat_percentage: 20,
    vat_amount: 250.00,
    gross: 1500.00,
    cis: 0,
    from_address: "123 Business Park\nLondon, UK\nTax Id: 123-45-6789\nIBAN: GB12ABCD12345678901234",
    to_address: "456 Corporate Avenue\nManchester, UK\nTax Id: 987-65-4321",
    payment_details: "Net 30",
    items: [
      {
        name: "Premium Copy Paper A4 80gsm White (5 Reams)",
        price: 24.99
      },
      {
        name: "Ballpoint Pens Black Medium (Box of 50)",
        price: 12.50
      },
      {
        name: "HP 305X High Yield Black Original LaserJet Toner Cartridge",
        price: 89.99
      },
      {
        name: "Spiral Notebooks College Ruled (Pack of 12)",
        price: 18.99
      },
      {
        name: "Office Desk Chair - Ergonomic Design",
        price: 249.99
      },
      {
        name: "Dell UltraSharp 27-inch 4K Monitor",
        price: 449.99
      },
      {
        name: "Wireless Keyboard and Mouse Combo",
        price: 59.99
      },
      {
        name: "Filing Cabinet - 4 Drawer",
        price: 179.99
      },
      {
        name: "Document Shredder - Cross Cut",
        price: 129.99
      },
      {
        name: "Desk Organizer Set",
        price: 33.57
      }
    ],
    bank_account_details: "IBAN: GB12ABCD12345678901234",
    pdf_url: "https://xelp-flowise.s3.amazonaws.com/KnowledgeBase/2a29dbb8-3847-4133-a14e-e13f55652554/2a29dbb8-3847-4133-a14e-e13f55652554_VISIONXELP_scanner@baileygroup.co.uk_20250625_161931.pdf"
  },
  {
    id: "3",
    invoice_number: "12345678",
    vat_number: "GB987654321",
    invoice_credit_note: "Invoice",
    date: "23-09-2016",
    description_particulars: "IT consulting services including system analysis, software development, and technical support.",
    supplier_name: "TechSolutions Inc.",
    net: 8750.00,
    vat_percentage: 20,
    vat_amount: 1750.00,
    gross: 10500.00,
    cis: 0,
    from_address: "789 Tech Avenue\nSan Francisco, CA 94105\nTax Id: 456-78-9012\nIBAN: US12TECH98765432109876",
    to_address: "321 Corporate Blvd\nNew York, NY 10001\nTax Id: 654-32-1098",
    payment_details: "Due on receipt",
    items: [
      {
        name: "System Analysis and Requirements Gathering (40 hours)",
        price: 4000.00
      },
      {
        name: "Software Development (30 hours)",
        price: 3750.00
      },
      {
        name: "Technical Support and Training (10 hours)",
        price: 1000.00
      }
    ],
    bank_account_details: "IBAN: US12TECH98765432109876",
    pdf_url: "https://xelp-flowise.s3.amazonaws.com/KnowledgeBase/2a29dbb8-3847-4133-a14e-e13f55652554/2a29dbb8-3847-4133-a14e-e13f55652554_VISIONXELP_scanner@baileygroup.co.uk_20250625_161931.pdf"
  },
  {
    id: "4",
    invoice_number: "45678901",
    vat_number: "FR12345678",
    invoice_credit_note: "Invoice",
    date: "15-10-2016",
    description_particulars: "Marketing services including social media management, content creation, and digital advertising.",
    supplier_name: "MarketPro Agency",
    net: 3500.00,
    vat_percentage: 20,
    vat_amount: 700.00,
    gross: 4200.00,
    cis: 0,
    from_address: "456 Creative Street\nParis, France\nTax Id: 789-01-2345\nIBAN: FR76MARK0123456789012345",
    to_address: "987 Brand Road\nLondon, UK\nTax Id: 012-34-5678",
    payment_details: "Net 15",
    items: [
      {
        name: "Social Media Management (Monthly Package)",
        price: 1200.00
      },
      {
        name: "Content Creation (10 Articles)",
        price: 1500.00
      },
      {
        name: "Digital Advertising Campaign",
        price: 800.00
      }
    ],
    bank_account_details: "IBAN: FR76MARK0123456789012345",
    pdf_url: "https://xelp-flowise.s3.amazonaws.com/KnowledgeBase/2a29dbb8-3847-4133-a14e-e13f55652554/2a29dbb8-3847-4133-a14e-e13f55652554_VISIONXELP_scanner@baileygroup.co.uk_20250625_161931.pdf"
  }
];

const MultiInvoiceViewPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedInvoiceId, setExpandedInvoiceId] = useState<string | null>(null);
  const [selectedSupplier, setSelectedSupplier] = useState<string | null>(null);
  
  // Get unique suppliers for filter
  const suppliers = Array.from(new Set(mockInvoices.map(invoice => invoice.supplier_name)));
  
  // Filter invoices based on search term and selected supplier
  const filteredInvoices = mockInvoices.filter(invoice => {
    const matchesSearch = 
      invoice.invoice_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.supplier_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.description_particulars.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesSupplier = !selectedSupplier || invoice.supplier_name === selectedSupplier;
    
    return matchesSearch && matchesSupplier;
  });
  
  // Toggle expanded state for an invoice
  const toggleInvoiceExpand = (id: string) => {
    setExpandedInvoiceId(expandedInvoiceId === id ? null : id);
  };
  
  // Clear all filters
  const clearFilters = () => {
    setSearchTerm('');
    setSelectedSupplier(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4 mb-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
        >
          <ArrowLeftIcon className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-semibold">Multiple Invoices View</h1>
      </div>
      
      {/* Search and Filters */}
      <div className="flex flex-wrap gap-4 items-center">
        <div className="flex items-center bg-white dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600 px-3 py-2 w-full max-w-md">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 dark:text-gray-300 mr-2" />
          <input
            type="text"
            placeholder="Search invoices..."
            className="flex-1 outline-none text-sm text-gray-700 dark:text-gray-200 bg-transparent placeholder-gray-400 dark:placeholder-gray-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <div className="relative">
          <select
            value={selectedSupplier || ''}
            onChange={(e) => setSelectedSupplier(e.target.value || null)}
            className="appearance-none bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 pr-8 text-sm text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="" className="dark:bg-gray-700">All Suppliers</option>
            {suppliers.map((supplier, index) => (
              <option key={index} value={supplier} className="dark:bg-gray-700">{supplier}</option>
            ))}
          </select>
          <FileTextIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 dark:text-gray-300" />
        </div>
        
        {(searchTerm || selectedSupplier) && (
          <button
            onClick={clearFilters}
            className="text-sm text-primary hover:underline dark:text-blue-400 dark:hover:text-blue-300"
          >
            Clear Filters
          </button>
        )}
      </div>
      
      {/* Invoice Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredInvoices.map(invoice => (
          <InvoiceCard
            key={invoice.id}
            invoice={invoice}
            expanded={expandedInvoiceId === invoice.id}
            onToggleExpand={() => toggleInvoiceExpand(invoice.id)}
          />
        ))}
      </div>
      
      {/* No results message */}
      {filteredInvoices.length === 0 && (
        <div className="text-center py-8">
          <p className="text-gray-500 dark:text-gray-400">No invoices found matching your criteria.</p>
        </div>
      )}
    </div>
  );
};

export default MultiInvoiceViewPage;
